import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
} from '@angular/core';
import { HighlightIndices } from '@rivethealth/data/options';

type Chunk = {
  highlight: boolean;
  text: string;
};

export function chunks(
  text: string,
  highlightIndices: HighlightIndices,
): Chunk[] {
  let lastEnd = 0;
  const chunks = [];
  highlightIndices.forEach(indexSet => {
    chunks.push(
      {
        highlight: false,
        text: text.substring(lastEnd, indexSet[0]),
      },
      {
        highlight: true,
        text: text.substring(indexSet[0], indexSet[1] + 1),
      },
    );
    lastEnd = indexSet[1] + 1;
  });
  chunks.push({
    highlight: false,
    text: text?.substring(lastEnd, text.length),
  });
  return chunks.filter(chunk => chunk.text);
}

@Component({
  selector: 'fuzzy-highlight',
  templateUrl: './fuzzy-highlight.component.html',
  styleUrls: ['./fuzzy-highlight.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FuzzyHighlightComponent implements OnChanges {
  @Input() text: string;
  @Input() indices: HighlightIndices;
  chunks: Chunk[];

  ngOnChanges() {
    this.chunks = chunks(this.text, this.indices);
  }
}
